import "./App.css";
import React from "react";
import MyRoutes from "./app/MyRoutes.tsx";
import "./app/auth/httpConfig";

const App = () => {
  return (
    <div>
      <MyRoutes />
    </div>
  );
};

export default App;
